/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../../components/Cards/Card";
import { getDomainBrandIdentity } from "../../../../../store/actions/domain-brand.action";
import { fetchAppLanguage } from "../../../../../utils/helpers/logicHelper";
import { fetchSubDomain } from "../../../../../utils/services/baseUrl";
import { ManagerService } from "../../../../../utils/services/manager.service";

function CircleLogin({ dictionary }) {
  const dispatch = useDispatch();
  const subdomain = fetchSubDomain();
  const selectedLanguage = fetchAppLanguage();
  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableCircle, setEnableCircle] = useState(false);
  const [enable, setEnable] = useState(false);

  const onChangeInputValue = (e) => {
    setEnable(e.target.checked);
  };

  const updateBrandSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.updateBrandSettings(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(getDomainBrandIdentity(subdomain, selectedLanguage["id"]));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setEnableCircle(!enableCircle)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {enableCircle ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary
              ? dictionary["para_enable_circle_login"]
              : "Enable Circle Login Page"}
          </li>
          <Collapse in={enableCircle}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {dictionary
                  ? dictionary["para_enable_or_disable_the_circle_login..."]
                  : `Enable or disable the circle login page in your application to your users.`}
              </h6>
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-5 mb-3">
                  <div className="col-md-6 col-lg-6">
                    <div className="py-3">
                      <input
                        type={"checkbox"}
                        name={"enable"}
                        id={"enable"}
                        className="pe-3 check-box"
                        onChange={(e) => onChangeInputValue(e)}
                      />
                      <span className="ps-2 align-top">
                        {dictionary ? dictionary["para_enable"] : "Enable"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 float-end mb-3">
                  <button
                    onClick={() =>
                      updateBrandSettings({ enableCircleLogin: enable })
                    }
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                  >
                    {dictionary ? dictionary["b_update"] : "UPDATE"}&nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default CircleLogin;
